'use strict';

var _isString = require('lodash/isString.js');
var _reduce = require('lodash/reduce.js');

var deps = {
  isString: _isString,
  reduce: _reduce,
};

module.exports = deps;
